import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import splitObject from './splitObject';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js"; // Timeline

var propTypes = {
  /** 指定圆圈颜色 */
  color: PropTypes.string,
  dot: PropTypes.node,
  pending: PropTypes.bool
};
var defaultProps = {
  color: 'primary',
  last: false,
  pending: false,
  dot: null
};
var TimelineItem = (_dec = WebUI({
  name: "timeline-item",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(TimelineItem, _React$Component);

  var _super = _createSuper(TimelineItem);

  function TimelineItem() {
    _classCallCheck(this, TimelineItem);

    return _super.apply(this, arguments);
  }

  _createClass(TimelineItem, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _splitObject = splitObject(this.props, ['clsPrefix', 'color', 'last', 'children', 'pending', 'className', 'dot']),
          _splitObject2 = _slicedToArray(_splitObject, 2),
          _splitObject2$ = _splitObject2[0],
          clsPrefix = _splitObject2$.clsPrefix,
          color = _splitObject2$.color,
          last = _splitObject2$.last,
          children = _splitObject2$.children,
          pending = _splitObject2$.pending,
          className = _splitObject2$.className,
          dot = _splitObject2$.dot,
          restProps = _splitObject2[1];

      var itemClassName = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix), true), _defineProperty(_classNames, "".concat(clsPrefix, "-last"), last), _defineProperty(_classNames, "".concat(clsPrefix, "-pending"), pending), _classNames), className);
      var dotClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(clsPrefix, "-head"), true), _defineProperty(_classNames2, "".concat(clsPrefix, "-head-custom"), dot), _defineProperty(_classNames2, "".concat(clsPrefix, "-head-").concat(color), true), _classNames2));
      return /*#__PURE__*/React.createElement("li", _extends({}, restProps, {
        className: itemClassName
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-tail")
      }), /*#__PURE__*/React.createElement("div", {
        className: dotClassName,
        style: {
          borderColor: /blue|red|green/.test(color) ? null : color
        }
      }, dot), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-content")
      }, children));
    }
  }]);

  return TimelineItem;
}(React.Component)) || _class);
TimelineItem.propTypes = propTypes;
export default TimelineItem;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timeline/src/TimelineItem.js